module.exports = __webpack_public_path__ + "static/media/2 (49).7b6923d5.jpg";